import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE,
  timeout: 10000,
  headers: { 'Accept': 'application/json' }
})

api.interceptors.request.use(addSessionHeader)

export default api

function addSessionHeader (config) {
  const token = localStorage.getItem('idToken')
  if (!token) { return config }
  config.headers.Authorization = `Bearer ${token}`
  return config
}
